import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { FEATURES } from 'consts';
import { useRecording } from 'useCase';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { RECORDING_STATUS } from 'state/store/recording/types';
import { selectRecordingStatus } from 'state/selectors';
import { ShapeVariant, SizeVariant } from 'ui/components/ControlButton/types';
import { LoadingRecordButton, RecordInProgressButton, StartRecordButton } from '../RecordButton';

interface RecordPanelProps {
    buttonShape?: ShapeVariant;
    buttonSize?: SizeVariant;
}

export const RecordPanel = observer(({ buttonShape, buttonSize }: RecordPanelProps) => {
    const { startRecording, stopRecording } = useRecording();
    const isRecordingEnabled = isFeatureOn(FEATURES.VCS_RECORDING_ENABLED);
    const status = selectRecordingStatus();

    const handleStartRecording = useCallback(() => {
        startRecording();
    }, []);

    const handleStopRecording = useCallback(() => {
        stopRecording();
    }, []);

    if (!isRecordingEnabled) return null;

    if (status === RECORDING_STATUS.WAITING_FOR_START) {
        return <LoadingRecordButton buttonShape={buttonShape} buttonSize={buttonSize} />;
    }

    if (status === RECORDING_STATUS.RECORDING || status === RECORDING_STATUS.STOPPING) {
        return (
            <RecordInProgressButton
                onClick={handleStopRecording}
                disabled={status === RECORDING_STATUS.STOPPING}
                buttonShape={buttonShape}
                buttonSize={buttonSize}
            />
        );
    }

    return <StartRecordButton onClick={handleStartRecording} buttonShape={buttonShape} buttonSize={buttonSize} />;
});
